import * as React from 'react';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { getProductImageUrl } from '../../../mappers/server-to-client/utils/get-product-image-url.js';
import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { UnpublishedProductImage } from './UnpublishedProductImage.js';

const UnpublishedProductImageContainer = ()=>{
    const { activeVariant: { displayName , media  } ,  } = useProductData();
    const imageUrl = getProductImageUrl(media);
    return /*#__PURE__*/ React.createElement(UnpublishedProductImage, {
        src: imageUrl,
        alt: displayName
    });
};

export { UnpublishedProductImageContainer };
//# sourceMappingURL=UnpublishedProductImageContainer.js.map
